// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"2f26c2dc","133":"27d8a419","182":"a91f8b43","801":"52714718"}[chunkId] + ".chunk.js";
};